export default __webpack_public_path__ + "static/media/crowd-vision-thumbnail.ae2b3e31.png";